import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/api/client";
import { Sprout, Bug, Shield, Zap, Leaf, FlaskConical, TrendingUp, Wrench, Droplets, SprayCan, Tractor, ArrowRight } from "lucide-react";
import SeoHead, { breadcrumbJsonLd } from "@/components/seo/SeoHead";

const ICONS = { Sprout, Bug, Shield, Zap, Leaf, FlaskConical, TrendingUp, Wrench, Droplets, SprayCan, Tractor };

const Categories = () => {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  return (
    <div className="container-fah py-10 sm:py-16" data-testid="page-categories">
      <SeoHead
        title="Shop by Category — Seeds, Pesticides, Fertilizers & More"
        description="Browse all agriculture categories on FarmersAgroHub: Seeds, Pesticides, Bio Fertilizers, Irrigation, Sprayers, Farm Machinery and Agriculture Tools. Genuine products from verified sellers."
        path="/categories"
        jsonLd={breadcrumbJsonLd([{ name: "Home", url: "/" }, { name: "Categories", url: "/categories" }])}
      />
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.15em] text-primary font-semibold mb-2">Explore</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">All Categories</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">Browse our complete range of agriculture inputs — from seeds and crop protection to heavy farm machinery.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        {cats.map((c) => {
          const Icon = ICONS[c.icon] || Sprout;
          return (
            <Link key={c.slug} to={`/category/${c.slug}`} className="card-fah hover-lift overflow-hidden group" data-testid={`cat-tile-${c.slug}`}>
              <div className="aspect-[5/3] bg-muted relative overflow-hidden">
                <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                <div className="absolute top-3 left-3 w-10 h-10 rounded-xl bg-white/90 flex items-center justify-center"><Icon className="w-5 h-5 text-primary" /></div>
              </div>
              <div className="p-4">
                <div className="font-semibold text-foreground group-hover:text-primary flex items-center justify-between">
                  {c.name} <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition" />
                </div>
                <div className="text-xs text-muted-foreground mt-1">{c.description}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Categories;
